import { Trans, useTranslation } from 'react-i18next'

import { Alert, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import { errorTypes } from '../constants'
import * as Styles from './styles'

const ShippingMethodName = ({ name, internalName, code, onChange, errors = [], internalId }) => {
  const { t } = useTranslation()

  const handleChangeName = event => {
    const name = event.target.value
    onChange({ name })
  }

  const handleChangeInternalName = event => {
    const internalName = event.target.value
    const baseCode = internalName.toLowerCase().replace(/ /g, '-')
    const code = internalId ? `${baseCode}-${internalId}` : baseCode
    onChange({ internal_name: internalName, code })
  }

  const shouldShowError = errorType => {
    return errors.find(error => error.type === errorType)
  }

  return (
    <Styles.Container id={errorTypes.nameOrInternalNameEmpty}>
      <Text type="titleS">
        <Trans i18nKey="shippingMethodName">Nombre</Trans>
      </Text>
      <InputWithLabel
        label={t('Nombre interno')}
        value={internalName}
        onChange={handleChangeInternalName}
        error={shouldShowError(errorTypes.internalNameEmpty)}
        helperText={shouldShowError(errorTypes.internalNameEmpty) && t('Este campo es obligatorio')}
      />
      <InputWithLabel
        label={t('Nombre público')}
        value={name}
        onChange={handleChangeName}
        error={shouldShowError(errorTypes.nameEmpty)}
        helperText={shouldShowError(errorTypes.nameEmpty) && t('Este campo es obligatorio')}
      />
      {internalId && (
        <Alert type="info">
          {t('El identificador interno se verá así')}: <strong>{code}</strong>
        </Alert>
      )}
    </Styles.Container>
  )
}

export default ShippingMethodName
